import React, { useEffect, useState } from "react";

const CommonTable = ({
  data,
  headers,
  cellFunction,
  cellFunctionIndex,
  rowAction = false,
  rowActionContent,
  rowActionHeadName = "",
  rows = 9,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [tableData, setTableData] = useState([]);
  const totalPages = Math.ceil(data?.length / rows);
  const [tableHeaders, setTableHeaders] = useState([]);

  useEffect(() => {
    if (headers && data) {
      setTableHeaders(headers);
      setTableData(data);
    } else {
      setTableHeaders([]);
      setTableData([]);
    }
  }, []);
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const displayedData = data?.slice(
    (currentPage - 1) * rows,
    currentPage * rows
  );

  return (
    <>
      <div className="table_default_wrap">
        <table className="table_default">
          <thead>
            <tr>
              {headers?.map((item, i) => (
                <th key={i}>{item?.label}</th>
              ))}
              {rowAction && <th>{rowActionHeadName || ""}</th>}
            </tr>
          </thead>
          <tbody>
            {displayedData?.map((item, rowIndex) => (
              <tr key={rowIndex} className="border">
                {headers.map((head, index) => (
                  <td
                    key={index}
                    onClick={
                      cellFunction && cellFunctionIndex === index + 1
                        ? cellFunction(item)
                        : () => {}
                    }
                  >
                    {head?.index ? rowIndex + 1 : item[head?.key]}
                  </td>
                ))}
                {rowAction && (
                  <td>{rowActionContent ? rowActionContent(item) : ""}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pagination_wrap">
        <button
          className="pagination_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &lt;
        </button>
        {currentPage > 1 && (
          <button
            className="px-3 py-1 border rounded-md bg-gray-100"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            {currentPage - 1}
          </button>
        )}
        <button className="pagination_active">{currentPage}</button>
        {currentPage < totalPages && (
          <button
            className="pagination_btn"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            {currentPage + 1}
          </button>
        )}
        <button
          className="pagination_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          &gt;
        </button>
      </div>
    </>
  );
};

export default CommonTable;
